/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通情報
 */
export interface Sgkb575aResCtrCommonInfo {
    /** 
     * 契約開始日区分：半角英数混在
     */
    ctrstrDateDiv?: string;
    /** 
     * 契約開始日区分名称：全角半角混在
     */
    ctrstrDateDivAname?: string;
    /** 
     * 契約開始日付：日付YYYYMMDD
     */
    ctrstrDate?: string;
    /** 
     * 契約適用日付：日付YYYYMMDD
     */
    ctrApplyDate?: string;
    /** 
     * 契約終了日区分：半角英数混在
     */
    ctrendDateDiv?: string;
    /** 
     * 契約終了日区分名称：全角半角混在
     */
    ctrendDateDivAname?: string;
    /** 
     * 契約終了年月：日付YYYYMM
     */
    ctrendYm?: string;
    /** 
     * 契約終了日付：日付YYYYMMDD
     */
    ctrendDate?: string;
    /** 
     * 契約変更日区分：半角英数混在
     */
    ctrchgDateDiv?: string;
    /** 
     * 契約変更日区分名称：全角半角混在
     */
    ctrchgDateDivAname?: string;
    /** 
     * 契約変更年月：日付YYYYMM
     */
    ctrchgYm?: string;
    /** 
     * 契約変更日付：日付YYYYMMDD
     */
    ctrChgDate?: string;
    /** 
     * 請求月度区分：半角英数混在
     */
    claimMntdiv?: string;
    /** 
     * 請求月度区分名称：全角半角混在
     */
    claimMntdivAname?: string;
    /** 
     * 料金計算回分：半角数字
     */
    chargeCalcKaibun?: string;
    /** 
     * 販売形態コード：半角英数混在
     */
    salfrmCode?: string;
    /** 
     * 販売形態コード名称：全角半角混在
     */
    salfrmCodeAname?: string;
    /** 
     * 中継店内部お客さま番号：半角数字
     */
    rlyisdVisitNo?: string;
    /** 
     * 中継店申込番号：半角英数混在
     */
    rlysrnNo?: string;
    /** 
     * 中継店担当者名：全角文字
     */
    rlystrFname?: string;
    /** 
     * 取次店発行お客さま番号：半角英数混在
     */
    agnissVisitNo?: string;
    /** 
     * プロダクトコード：半角英数混在
     */
    prdCode?: string;
    /** 
     * プロダクトコード名称：全角文字
     */
    prdCodeAname?: string;
    /** 
     * サービス契約締結日付：日付YYYYMMDD
     */
    prdCtrDate?: string;
    /** 
     * サービス契約解約理由コード：半角数字
     */
    srvbrkRsncod?: string;
    /** 
     * サービス契約解約理由コード名称：全角半角混在
     */
    srvbrkRsncodAname?: string;
    /** 
     * 契約管轄組織番号：半角英数混在
     */
    ctrSosikiId?: string;
    /** 
     * 契約締結組織番号：半角英数混在
     */
    tantoSosikiId?: string;
    /** 
     * 契約締結社員番号：半角英数混在
     */
    tantoStaffNo?: string;
    /** 
     * 契約解約組織番号：半角英数混在
     */
    breakSosikiId?: string;
    /** 
     * 契約解約社員番号：半角英数混在
     */
    breakStaffNo?: string;
    /** 
     * 自用フラグ：半角英数混在
     */
    selfuseFlg?: string;
    /** 
     * 自用フラグ名称：全角半角混在
     */
    selfuseFlganame?: string;
    /** 
     * 単価表コード：半角英数混在
     */
    tankatableCode?: string;
    /** 
     * 業種（大分類）：半角英数混在
     */
    gyoshuLargebunrui?: string;
    /** 
     * 業種（大分類）名称：全角半角混在
     */
    gyoshuLargebunruiAname?: string;
    /** 
     * 業種（中分類）：半角英数混在
     */
    gyoshuMediumbunrui?: string;
    /** 
     * 業種（中分類）名称：全角半角混在
     */
    gyoshuMediumbunruiAname?: string;
    /** 
     * 業種（小分類）：半角英数混在
     */
    gyoshuSmallbunrui?: string;
    /** 
     * 業種（小分類）名称：全角半角混在
     */
    gyoshuSmallbunruiAname?: string;
    /** 
     * 延滞利息対象フラグ：半角英数混在
     */
    dryrskTargetflag?: string;
    /** 
     * 延滞利息対象フラグ名称：全角半角混在
     */
    dryrskTargetflagAname?: string;
}
